import React, { PropsWithChildren } from 'react';
import { Paper, PaperProps, Stack, SxProps, Theme } from '@mui/material';

interface SectionProps {
  header?: React.ReactNode;
  headerParentSx?: SxProps<Theme>
}

export function Section({ header, children, headerParentSx, ...paperProps }: PropsWithChildren<SectionProps> & PaperProps) {
  return (
    <Paper
      variant='outlined'
      elevation={0}
      sx={{
        borderRadius: 0.5,
        marginBottom: 2.5,
        ...paperProps.sx
      }}
      {...paperProps}
    >
      {header &&
        <Stack
          flexWrap="wrap"
          sx={{
            paddingY: 1.25,
            paddingX: 2,
            backgroundColor: 'grey.A100',
            // not in the palette but matching shipment detail color, change if design is updated to use palette color
            borderColor: '#ddd',
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            ...headerParentSx
          }}
        >
          {header}
        </Stack>
      }
      {children}
    </Paper>
  )
}
